import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(() => {
  // Watch the session state and update Sentry user context accordingly.
  // This covers initial page load, login, register, and logout.
  const session = useState<{
    _id: string;
    username: string;
    primaryEmail?: string;
  } | null>("session");

  watch(
    session,
    (newSession) => {
      if (newSession?._id) {
        Sentry.setUser({
          id: newSession._id,
        });
      } else {
        Sentry.setUser(null);
      }
    },
    { immediate: true }
  );
});
